declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleMedicineDataRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbaddmedicine',
  templateUrl: './addscanmedicine.modal.html',
  styleUrls: ['./addscanmedicine.modal.scss']
})

export class NgbAddScanMedicineModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  //@Input() CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  @Input() ActivityCode: number;
  @Input() CycleCode: number;
  @Input() ActorCode1: number;
  @Input() MedicineCode: number;
  @Input() ClinicalOrderItem: number;
    @Input() ScanDate: Date;
    @Input() TcModelName: string;
  @Input() Typeofscreen: string;
  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, private parserFormatter: NgbDateParserFormatter,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }
  ActorCode: number;
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.ShowService = false;
    //alert(this.Typeofscreen);
    //this.StartDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      if (this.ScanDate != null) {
          var SValidFrom = new Date(this.ScanDate);
          if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.StartDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
              }
          }
      }
  }








  onSubmit() {

      this.StartRefreshing();
      this.spinner.show();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
      this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = new Date(this.parserFormatter.format(this.StartDate));
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
    this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
    //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.Duration = 2;
    //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = 0;
    this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  onAssignedToActorCode(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = event;
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = event;
      //alert( this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode)
      // console.log('event--_>' + event);
      //   }
    }

  }



}
